export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6656.ccaec1f1.jpg";